import { render, staticRenderFns } from "./prodottiAssociatiDistributori.vue?vue&type=template&id=cbd6dbe4&"
import script from "./prodottiAssociatiDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottiAssociatiDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports